import { render, staticRenderFns } from "./AudioCallWrapper.vue?vue&type=template&id=74bf73d6&scoped=true&"
import script from "./AudioCallWrapper.vue?vue&type=script&lang=js&"
export * from "./AudioCallWrapper.vue?vue&type=script&lang=js&"
import style0 from "./AudioCallWrapper.vue?vue&type=style&index=0&id=74bf73d6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74bf73d6",
  null
  
)

export default component.exports